export default "__VITE_ASSET__MecTTVHL__"